import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CaseService } from 'src/app/services/case/data/case.service';
import { ErrorService } from 'src/app/services/error/error.service';
import { StaticSiteService } from 'src/app/services/static-site/static-site.service';

@Component({
    selector: 'app-iframe-dialog',
    templateUrl: './iframe-dialog.component.html',
    styleUrls: ['./iframe-dialog.component.scss'],
    standalone: false
})
export class IframeDialogComponent implements OnInit {
  newTabMode: boolean = false;

  iframeSafeUrl: any;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer,
    private router: Router,
    private caseService: CaseService,
    private errorService: ErrorService,
    private staticSiteService: StaticSiteService
  ) {}

  ngOnInit(): void {
    if (this.data) {
      this.iframeSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.data);
    } else {
      this.newTabMode = true;
      this.getCaseIframe(this.router.url.split('/')[2]);
    }
  }

  getCaseIframe(id: string) {
    this.caseService.getCaseIframeUrl(id).subscribe({
      next: d => {
        const url = d.staticSite ? this.staticSiteService.buildPublicUrl(d.staticSite.id) : d.iframeUrl;
        this.iframeSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      },
      error: e => {
        this.errorService.onError(e);
      },
    });
  }
}
